import React from 'react';
import ButtonBlock from './ButtonBlock';
import { BUTTON_STYLE_SCHEMA, resolveButtonBorder } from '../../../../shared/boxes/button/buttonStyles';
import { styleDefaults } from '../../../../shared/theme/styleSchema';
import { puckColorField } from '../../../puck/fields/createPuckColorField';
import ButtonIconField from './ButtonIconField';
import { puckBorderField } from '../../../puck/fields/puckBorderField';
import { puckButtonLinkField } from '../../../puck/fields/ButtonLinkField';
import { puckButtonStyleField } from '../../../puck/fields/ButtonStylePicker';
import { puckButtonStyleSettingsField } from '../../../puck/fields/ButtonStyleField';
import { puckHorizontalAlignField } from '../../../puck/fields/puckHorizontalAlignField';
import { puckVerticalAlignField } from '../../../puck/fields/puckVerticalAlignField';
import { puckVisibilityField } from '../../../puck/fields/puckVisibilityField';
import { puckSwitchField } from '../../../puck/fields/puckSwitchField';
import { puckAdvancedSectionField, puckSectionField, puckStyleGallerySectionField } from '../../../puck/fields/puckSectionField';
import { withThemedFieldValues } from '../../../puck/fields/themedFieldValues';
import { puckTextRolesField } from '../../../puck/fields/TextRolesField';
import {
  themedBlockProps, themedBlockResolveData, themedBlockResolveFields,
} from '../../../puck/themedBlocks';

const buttonBlockConfig = {
  label: 'Bouton',
  defaultProps: {
    label: 'En savoir plus',
    url: '',
    ...styleDefaults(BUTTON_STYLE_SCHEMA),
    icon: '',
    iconColor: '#ffffff',
    alignHorizontal: 'center',
    alignVertical: 'center',
    showCaption: false,
    caption: '',
    fullWidth: false,
    isVisible: true,
  },
  // Le libellé s'édite UNIQUEMENT sur le canvas (règle InfoCard) : pas de
  // champ `label` en sidebar.
  fields: withThemedFieldValues('button', {
    isVisible: puckVisibilityField(),
    /* `link` n'entre PAS dans defaultProps : un bouton déjà en base n'en a pas,
       et un objet par défaut masquerait son ancienne prop `url`, donc son lien.
       Le champ, lui, s'ouvre sur cette URL (cf. buttonLinkFromLegacy). */

    _section1: puckSectionField('Lien'),
    link: puckButtonLinkField(),
    showCaption: puckSwitchField('Sur-titre', 'Petit texte au-dessus du libellé, ex. « Chapitre suivant ». Il s’écrit sur le bouton.'),

    _sectionGallery: puckStyleGallerySectionField('Bouton'),
    /* La galerie écrit PLUSIEURS props (`buttonStyle` et `border`) par
       dispatch, elle n'a donc pas de prop à elle. Puck n'accepte qu'un champ
       par prop : elle se déclare sur `radius`, devenu sans champ depuis que
       l'arrondi vit dans `border`. Même arrangement qu'InfoCardStylePicker,
       déclaré sur `titleStyle`. */
    radius: puckButtonStyleField(),

    _section2: puckSectionField('Style'),
    color: puckColorField('Couleur du bouton'),
    size: {
      type: 'radio',
      label: 'Taille',
      options: [
        { label: 'Petit', value: 'sm' },
        { label: 'Moyen', value: 'md' },
        { label: 'Grand', value: 'lg' },
      ],
    },
    /* Tant que `border` est absent, le bouton rend celle reconstruite depuis
       l'ancien `radius` : c'est elle que le champ doit montrer. */
    border: puckBorderField('Bordures', {
      readDefaults: (props) => resolveButtonBorder({ radius: props.radius }),
    }),
    icon: {
      type: 'custom',
      label: 'Icône',
      render: (props) => <ButtonIconField {...props} />,
    },

    _sectionText: puckSectionField('Typographie'),
    textStyles: puckTextRolesField([
      { key: 'label', label: 'Libellé' },
      { key: 'caption', label: 'Sur-titre' },
    ]),

    _section3: puckSectionField('Affichage'),
    fullWidth: puckSwitchField('Pleine largeur', 'Le bouton occupe toute sa colonne, l’icône au bord opposé.'),
    alignHorizontal: puckHorizontalAlignField(),
    alignVertical: puckVerticalAlignField(undefined, { stretch: true }),

    _section4: puckAdvancedSectionField(),
    buttonStyle: puckButtonStyleSettingsField(),
  }),
  // Suit son style du thème, s'il en a un, retouches du thème comprises
  // (lien vivant, cf. puck/themedBlocks).
  resolveData: themedBlockResolveData('button'),
  resolveFields: themedBlockResolveFields('button'),
  render: (props) => <ButtonBlock {...themedBlockProps('button', props, props.puck?.metadata)} />,
};

export default buttonBlockConfig;
